import { ChannelUser, ChannelUserConversation, type Websocket } from 'entities/WebSocket'

export class ChannelsUser {
  constructor(private _websocket: Websocket) {}

  subscribeChannels = (user_id: number) => {
    new ChannelUser(
      {
        id: user_id,
      },
      this._websocket
    )
    new ChannelUserConversation(
      {
        id: user_id,
      },
      this._websocket
    )
  }
}
